// @flow
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

// Components
import MobileDatePicker from './MobileDatePicker';

// Selectors
import {
  getLocaleCode,
  getLanguageCode
} from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => ({
  locale: getLocaleCode(state),
  languageCode: getLanguageCode(state)
});

export default compose(
  injectIntl,
  connect(mapStateToProps)
)(MobileDatePicker);



// WEBPACK FOOTER //
// ./src/components/atoms/MobileDatePicker/MobileDatePickerContainer.js